export default {
  "app-layout": () => import("/home/forge/app.inaia.finance/layouts/AppLayout.vue").then(m => m.default || m),
  "outside-layout": () => import("/home/forge/app.inaia.finance/layouts/OutsideLayout.vue").then(m => m.default || m)
}